export default "__VITE_ASSET__DUWhC3I$__"